import { MenuItem } from "@mui/material";

export const generateMenuItemsFromBreakpoints = (breakpoints: number[], unit: string) => {
  const empty = <MenuItem value={''} key={'EMPTY'}></MenuItem>
  const items = breakpoints.map((breakpoint, index) => {
    const value = `${breakpoint} ${unit}`;
    return <MenuItem value={value} key={value}>{value}</MenuItem>
  });
  return [empty, ...items];
}